export default __webpack_public_path__ + "static/media/unlock.8e1daae5.svg";